import React from 'react';

export default function PrivacyPolicy() {
  return (
    <div dir="rtl" className="min-h-screen bg-[#e8e9eb]" style={{ fontFamily: 'Cairo, sans-serif' }}>
      <div className="max-w-4xl mx-auto px-6 py-20">
        {/* Header */}
        <div className="bg-[#141d3c] text-white px-12 py-10 rounded-lg mb-8 mt-32">
          <h1 className="text-3xl font-bold mb-3">سيـاسة الخصوصيـة - زان التسويقية الرقمية</h1>
          <p className="text-white/70">سارية اعتبارًا من 1 يناير 2026</p>
        </div>

        {/* Content */}
        <div className="bg-white px-12 py-10 rounded-lg shadow-sm">
          <div className="text-black/80 leading-loose space-y-8">
            {/* Introduction */}
            <p className="text-base">
              في زان، نحترم خصوصيتك ونلتزم بحماية بياناتك الشخصية بأقصى درجات الأمان. هذه السياسة توضح كيفية جمعنا، استخدامنا، وحمايتنا لبياناتك أثناء تعاملنا معك وتقديم خدماتنا.
            </p>

            {/* Section 1 */}
            <div>
              <h2 className="text-xl font-bold text-[#141d3c] mb-3">1. جمع البيانات</h2>
              <p>نقوم بجمع البيانات الضرورية فقط لتقديم الخدمات التي تطلبها، مثل: الاسم، البريد الإلكتروني، رقم الهاتف، تفاصيل المشروع أو الخدمة المطلوبة. لا نقوم بجمع أي بيانات غير ذات صلة بخدماتنا. جميع البيانات المستخدمة هي لأغراض تنفيذ الطلب فقط.</p>
            </div>

            {/* Section 2 */}
            <div>
              <h2 className="text-xl font-bold text-[#141d3c] mb-3">2. استخدام البيانات</h2>
              <ul className="space-y-1.5 mr-6">
                <li>• تستخدم البيانات حصريًا لتلبية طلباتك وتنفيذ الخدمات المطلوبة بدقة وفق مواصفاتك.</li>
                <li>• نحتفظ بالحق في استخدام بياناتك مؤقتًا للتواصل معك بشأن الطلب أو لتقديم الدعم الفني عند الحاجة.</li>
                <li>• البيانات لا تستخدم لأي أغراض تسويقية أو إعلانية دون موافقتك الصريحة.</li>
              </ul>
            </div>

            {/* Section 3 */}
            <div>
              <h2 className="text-xl font-bold text-[#141d3c] mb-3">3. مشاركة البيانات مع أطراف ثالثة</h2>
              <ul className="space-y-1.5 mr-6">
                <li>• زان لا تشارك بياناتك الشخصية مع أي جهة خارجية تحت أي ظرف.</li>
                <li>• أي بيانات يتم استخدامها مع مزودي خدمات خارجيين (مثل الطباعة أو الخدمات اللوجستية) تظل سرية وتستخدم فقط لإنجاز طلبك.</li>
              </ul>
            </div>

            {/* Section 4 */}
            <div>
              <h2 className="text-xl font-bold text-[#141d3c] mb-3">4. ملكية العمل بعد التنفيذ</h2>
              <ul className="space-y-1.5 mr-6">
                <li>• جميع الأعمال التي نقوم بتنفيذها لك تصبح ملكك بعد الدفع.</li>
                <li>• ومع ذلك، يظل زان المنفذ الأصلي للعمل، ولا يتم نسب التنفيذ لك أو لأي طرف آخر.</li>
                <li>• لا تتحمل زان أي مسؤولية عن بيع أو استخدام العمل بعد تسليمه لك.</li>
              </ul>
            </div>

            {/* Section 5 */}
            <div>
              <h2 className="text-xl font-bold text-[#141d3c] mb-3">5. أمان البيانات</h2>
              <ul className="space-y-1.5 mr-6">
                <li>• نتخذ جميع التدابير الأمنية اللازمة لحماية بياناتك أثناء عملية تقديم الخدمة.</li>
                <li>• نستخدم طرق تشفير وحماية مناسبة لضمان عدم تعرض البيانات لأي تسريب أو اختراق.</li>
              </ul>
            </div>

            {/* Section 6 */}
            <div>
              <h2 className="text-xl font-bold text-[#141d3c] mb-3">6. مدة الاحتفاظ بالبيانات</h2>
              <ul className="space-y-1.5 mr-6">
                <li>• لا نحتفظ بالبيانات الخاصة بك بعد إتمام الخدمة إلا إذا كان هناك سبب قانوني أو متطلبات إدارية.</li>
                <li>• بمجرد تسليم الخدمة وإتمام العملية، يتم مسح البيانات الشخصية بشكل كامل من أنظمتنا.</li>
              </ul>
            </div>

            {/* Section 7 */}
            <div>
              <h2 className="text-xl font-bold text-[#141d3c] mb-3">7. إخلاء المسؤولية</h2>
              <ul className="space-y-1.5 mr-6">
                <li>• زان غير مسؤولة عن أي استخدام ضار أو غير قانوني للخدمات بعد تسليمها لك.</li>
                <li>• أي استخدام للمنتجات أو الخدمات التي قدمناها يقع على مسؤوليتك الشخصية.</li>
              </ul>
            </div>

            {/* Section 8 */}
            <div>
              <h2 className="text-xl font-bold text-[#141d3c] mb-3">8. التحديثات على سياسة الخصوصية</h2>
              <ul className="space-y-1.5 mr-6">
                <li>• تحتفظ زان بالحق في تعديل هذه السياسة في أي وقت دون إشعار مسبق.</li>
                <li>• يُنصح العملاء بمراجعة هذه الصفحة بشكل دوري لمعرفة أي تغييرات.</li>
              </ul>
            </div>

            {/* Section 9 */}
            <div>
              <h2 className="text-xl font-bold text-[#141d3c] mb-3">9. القوانين المعمول بها</h2>
              <p>هذه السياسة تخضع وتفسر وفقًا للقوانين والأنظمة المعمول بها في المملكة العربية السعودية.</p>
            </div>

            {/* Section 10 */}
            <div>
              <h2 className="text-xl font-bold text-[#141d3c] mb-3">10. قبول الشروط</h2>
              <p>عند تقديم طلب الخدمة والدفع، فإنك توافق ضمنيًا على جميع أحكام هذه السياسة.</p>
            </div>

            {/* Section 11 */}
            <div className="pt-6 border-t-2 border-[#e8e9eb]">
              <h2 className="text-xl font-bold text-[#141d3c] mb-3">11. التواصل معنا</h2>
              <p className="mb-2">لأي استفسارات حول سياسة الخصوصية أو حماية بياناتك، يمكنك التواصل معنا عبر:</p>
              <ul className="space-y-1.5 mr-6">
                <li>• الهاتف: <span dir="ltr">+966 57 937 9779</span></li>
                <li>• البريد الإلكتروني: info@zan-mkt.com</li>
              </ul>
            </div>
          </div>
        </div>

        {/* Footer */}
        
      </div>
    </div>
  );
}